import {
  ValidateUnsubmittedResponse,
  MinifiedGetCalculationsResponse,
  ValidateUnsubmittedMinifiedResponse,
} from '@/validation-service/services/validationApi';

export function transformValidateServiceResponse(response: ValidateUnsubmittedResponse) {
  const isValid = isValidValidationServiceResponse(response);
  if (isValid) {
    const errorsAndWarnings = response.reduce(
      (acc, item) => {
        const errors = item.validationErrors.filter(
          (error) => error.severity === 'Critical' || error.severity === 'Error',
        );
        const warnings = item.validationErrors.filter((error) => error.severity === 'Warning');

        return {
          errors: acc.errors + errors.length,
          warnings: acc.warnings + warnings.length,
        };
      },
      {
        errors: 0,
        warnings: 0,
      },
    );
    return errorsAndWarnings;
  }

  return {
    errors: -1,
    warnings: -1,
  };
}

export function excludeWarningsFromValidationErrors(response: ValidateUnsubmittedResponse) {
  const isValid = isValidValidationServiceResponse(response);
  if (isValid) {
    return response.map((errorItem) => {
      return {
        ...errorItem,
        validationErrors: errorItem.validationErrors.filter(
          (innerItem) => innerItem.severity !== 'Warning',
        ),
      };
    });
  }
  return response;
}

function isValidValidationServiceResponse(response: ValidateUnsubmittedResponse) {
  return (
    Array.isArray(response) &&
    response.every((item) => item.validationErrors && Array.isArray(item.validationErrors))
  );
}

export function isValidCalculateResponse(response: MinifiedGetCalculationsResponse) {
  if (response && response.calculations.length > 0 && Object.keys(response.totals).length > 0) {
    return true;
  }

  return false;
}
export function isNoCalculation(response: MinifiedGetCalculationsResponse) {
  if (response && response.calculations.length === 0 && Object.keys(response.totals).length === 0) {
    return true;
  }

  return false;
}
export function isValidValidateUnsubmittedResponse(response: ValidateUnsubmittedMinifiedResponse) {
  if (response && response.errors !== undefined) {
    return true;
  }

  return false;
}
